import { render, staticRenderFns } from "./tjtdzyjsxy.vue?vue&type=template&id=17d8758c&scoped=true&"
import script from "./tjtdzyjsxy.vue?vue&type=script&lang=js&"
export * from "./tjtdzyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./tjtdzyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tjtdzyjsxy.vue?vue&type=style&index=1&id=17d8758c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d8758c",
  null
  
)

export default component.exports